import { render, staticRenderFns } from "./Automation2.vue?vue&type=template&id=11b76568"
import script from "./Automation2.vue?vue&type=script&lang=js"
export * from "./Automation2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports